import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { PAYMENTS_GATEWAYS_FEATURE_GROUP } from './group';

export const PAYMENTS_GATEWAYS_FEATURES = {
  READ: {
    guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f0200',
    name: 'payments_gateways:read',
    description: 'View connected gateways, payout accounts and fee settings',
    action: 'read',
    product: 'payments',
    parentGuid: PAYMENTS_GATEWAYS_FEATURE_GROUP.guid,
  },
  UPDATE: {
    guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f0201',
    name: 'payments_gateways:update',
    description: 'Connect, test and disconnect a gateway, and change who pays the fees',
    action: 'update',
    product: 'payments',
    parentGuid: PAYMENTS_GATEWAYS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { PAYMENTS_GATEWAYS_FEATURE_GROUP } from './group';

export const PAYMENTS_GATEWAYS_MODULE: FeatureModule = {
  product: 'payments',
  groups: [PAYMENTS_GATEWAYS_FEATURE_GROUP],
  features: featureList(PAYMENTS_GATEWAYS_FEATURES),
};
